import styled from '@emotion/styled/macro';
import {Avatar} from '@mui/material';
import {colors} from '@assets/colors';

export const AvatarStyled = styled(Avatar)`
  margin-left: auto;
  margin-top: auto;
  margin-bottom: auto;
  cursor: pointer;
  background-color: ${colors.theme.secondary.main};
  &:hover {
    filter: brightness(0.87);
  }
  &:active {
    filter: brightness(0.4);
  }
`
